import { render, staticRenderFns } from "./AccessForgotPassword.vue?vue&type=template&id=42972722"
import script from "./AccessForgotPassword.vue?vue&type=script&lang=js"
export * from "./AccessForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports